import React, { useState } from 'react';
import "./UniqueId.css";
import { Col, Container, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import NavigationBar from '../NavigationBar/NavigationBar';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';

function UniqueId() {
  const { uniqueId } = useParams();
  const [isLoggedIn] = useState(sessionStorage.getItem('login') === 'true');
  const admin_id = isLoggedIn && sessionStorage.getItem('admin_id');
  const [isCopied, setIsCopied] = useState(false);
  const navigate = useNavigate();

  const handleCopy = () => {
    navigator.clipboard.writeText(uniqueId);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const renderTooltip = (props) => (
    <Tooltip id="custom-tooltip" {...props} className="custom-tooltip">
      <div className="tooltip-content">
        {isCopied ? (
          <>
            <FaCheckCircle className="tooltip-icon" />
            <span>Copied!</span>
          </>
        ) : (
          <>
            <FaCopy className="tooltip-icon" />
            <span>Copy to clipboard</span>
          </>
        )}
      </div>
    </Tooltip>
  );

  const handleHome = () => {
    navigate('/adminIndex')
  }

  const handleNavigateNewRegistration = () => {
    navigate(`/regForm/${admin_id}`)
  }

  return (
    <>
      <div className='register-unique-id-generated'>
        <NavigationBar />
        <Container className='register-unique-id-generated-box w-50 w-md-75 w-lg-50 w-sm-75'>
          <Row className="justify-content-center">
            <Col xs={12} sm={12} md={6} lg={8} xl={8} className="text-center">
              <h3 className='success-message'>Registered Successfully</h3>
              <h3 className='unique-id-title'>Your unique ID</h3>
              <div className="unique-id-container">
                <div className="d-flex justify-content-between align-items-center registeration-show-unique-id">
                  <h3 className="p-3 mb-0 flex-grow-1 text-center unique-id-text">{uniqueId}</h3>
                  <div className="text-end unique-id-copy-icon">
                    <OverlayTrigger
                      placement="top"
                      overlay={renderTooltip}
                      delay={{ show: 200, hide: 300 }}
                    >
                      <div className="copy-button-wrapper">
                        {isCopied ? (
                          <FaCheckCircle
                            size={20}
                            className="cursor-pointer copy-success"
                            title="Copied!"
                          />
                        ) : (
                          <FaCopy
                            size={20}
                            className="cursor-pointer copy-icon"
                            onClick={handleCopy}
                            title="Copy to clipboard"
                          />
                        )}
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {isLoggedIn && (
            <div className='container-fluid'>
              <div className='row justify-content-center mt-4'>
                <div className='col-12 col-sm-12 col-md-8'>
                  <div className='d-flex flex-column flex-md-row justify-content-center gap-3 gap-md-5'>
                    <button className='unique-id-button' onClick={handleHome}>
                      Home
                    </button>
                    <button className='unique-id-button' onClick={handleNavigateNewRegistration}>
                      Registration
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Container>
      </div>
    </>
  );
}

export default UniqueId;